module.exports = __webpack_public_path__ + "img/plus-square-dotted.4f21f3ed.svg";